// extracted by mini-css-extract-plugin
module.exports = {"brandContainer":"_2MPaM","cardBrand":"lDCtE","cardImg":"_3k1Pm","cardLink":"_2NIUE"};